import React, { Component } from 'react'
import { connect } from 'react-redux'

import { verifyXanoApp } from 'utils/externalDatabases'
import { submitCopyApp } from 'utils/copyApp'

import { getApp } from 'ducks/apps'

import Modal from 'components/Shared/Modal'

import CopyAppForm from './Form'

class CopyApp extends Component {
  handleSubmit = formValues => {
    const { app } = this.props

    if (!app) {
      return
    }

    submitCopyApp(app, formValues)

    return this.handleCancel()
  }

  handleCancel = () => {
    const { match, history } = this.props
    const { appId } = match.params

    history.push(`/apps/${appId}/screens`)
  }

  render() {
    const { app } = this.props
    const isXanoApp = verifyXanoApp(app)
    const isResponsiveApp = app?.magicLayout
    const primaryPlatform = app?.primaryPlatform

    if (!app) {
      return null
    }

    const initialValues = {
      name: `${app.name} Copy`,
      copyAsResponsive: false,
      organizationId: app.OrganizationId,
      copyDatabase: '1',
    }

    if (primaryPlatform !== 'responsive') {
      initialValues.appType = 'legacy'
    }

    return (
      <Modal>
        <CopyAppForm
          onSubmit={this.handleSubmit}
          onCancel={this.handleCancel}
          initialValues={initialValues}
          isXanoApp={isXanoApp}
          isResponsiveApp={isResponsiveApp}
          primaryPlatform={primaryPlatform}
        />
      </Modal>
    )
  }
}

const mapStateToProps = (state, { match }) => ({
  app: getApp(state, match.params.appId),
})

export default connect(mapStateToProps)(CopyApp)
